import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.archive.viewer');
import { OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-portal-archive-viewer',
template: templateSource || '',
    styles: [``],
})
export class PortalArchiveViewerComponent implements OnInit {
    public loading: boolean = false;
    public listLoading: boolean = false;
    public importing: boolean = false;
    public importMode: string = 'html';
    public selectedId: string = '';
    public documents: any[] = [];
    public total: number = 0;
    public bundle: any = null;
    public preview: any = null;
    public viewerUrl: SafeResourceUrl | null = null;
    public pdfUrl: string = '';
    public adapters: any[] = [];
    public keyuptime: number = 0;
    public pdfFileName: string = '';

    public filters: any = {
        text: '',
        kind: '',
        status: ''
    };

    public draft: any = this.emptyDraft();

    constructor(@Inject( Service) public service: Service,@Inject( DomSanitizer)  private sanitizer: DomSanitizer) { }

    public async ngOnInit() {
        await this.service.init(null);
        this.selectedId = WizRoute.segment.id || '';
        await this.loadAdapters();
        await this.loadList();
        await this.loadDocument(this.selectedId || this.firstId());
    }

    public emptyDraft() {
        return {
            title: '',
            kind: 'proposal',
            status: 'draft',
            tags: '',
            summary: '',
            html: '',
            data_url: ''
        };
    }

    public firstId() {
        if (this.documents.length === 0) return '';
        return this.documents[0].id;
    }

    public async loadAdapters() {
        const { code, data }: any = await wiz.call('adapters');
        if (code === 401) return this.redirectAccess();
        if (code === 200) this.adapters = data || [];
    }

    public async loadList() {
        this.listLoading = true;
        await this.service.render();
        const { code, data }: any = await wiz.call('list', { ...this.filters, page: 1, dump: 50 });
        if (code === 401) return this.redirectAccess();
        if (code === 200) {
            this.documents = data.rows || [];
            this.total = data.total || 0;
        }
        this.listLoading = false;
        await this.service.render();
    }

    public async loadDocument(id: string = '') {
        if (!id) {
            this.bundle = null;
            this.preview = null;
            this.viewerUrl = null;
            this.pdfUrl = '';
            await this.service.render();
            return;
        }

        this.loading = true;
        this.selectedId = id;
        this.bundle = null;
        this.preview = null;
        this.viewerUrl = null;
        this.pdfUrl = '';
        await this.service.render();

        const { code, data }: any = await wiz.call('get', { id });
        if (code === 401) return this.redirectAccess();
        if (code === 200) {
            this.bundle = data;
            this.preview = data.preview;
            this.pdfUrl = data.current?.pdf_url || '';
            if (this.preview?.source_url) {
                this.viewerUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.preview.source_url);
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public async openDocument(item: any) {
        if (!item?.id) return;
        this.service.href(`/archive/${item.id}`);
        await this.loadDocument(item.id);
    }

    public searchAction() {
        this.keyuptime = new Date().getTime();
        const ref = this.keyuptime;
        setTimeout(async () => {
            if (ref !== this.keyuptime) return;
            await this.loadList();
        }, 250);
    }

    public async setFilter(key: string, value: string) {
        this.filters[key] = this.filters[key] === value ? '' : value;
        await this.loadList();
        if (!this.selectedId && this.firstId()) await this.loadDocument(this.firstId());
    }

    public statusClass(status: string) {
        switch (status) {
            case 'published': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case 'draft': return 'bg-amber-50 text-amber-700 border-amber-200';
            case 'archived': return 'bg-slate-50 text-slate-600 border-slate-200';
            default: return 'bg-slate-50 text-slate-600 border-slate-200';
        }
    }

    public typeClass(type: string) {
        if (type === 'pdf') return 'bg-rose-50 text-rose-700 border-rose-200';
        return 'bg-blue-50 text-blue-700 border-blue-200';
    }

    public adapterStatus(adapter: any) {
        return adapter?.available ? 'text-emerald-600' : 'text-slate-400';
    }

    public openImport(mode: string) {
        this.importMode = mode;
        this.importing = true;
        this.pdfFileName = '';
        this.draft = this.emptyDraft();
        this.draft.kind = mode === 'pdf' ? 'deck' : 'proposal';
    }

    public closeImport() {
        this.importing = false;
        this.draft = this.emptyDraft();
        this.pdfFileName = '';
    }

    public readHtmlFile() {
        const node = document.createElement('input');
        node.type = 'file';
        node.accept = '.html,.htm,text/html';
        node.onchange = () => {
            const file = node.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async () => {
                this.draft.html = String(reader.result || '');
                if (!this.draft.title) this.draft.title = file.name.replace(/\.html?$/i, '');
                await this.service.render();
            };
            reader.readAsText(file);
        };
        node.click();
    }

    public readPdfFile() {
        const node = document.createElement('input');
        node.type = 'file';
        node.accept = 'application/pdf,.pdf';
        node.onchange = () => {
            const file = node.files?.[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async () => {
                this.draft.data_url = String(reader.result || '');
                this.pdfFileName = file.name;
                if (!this.draft.title) this.draft.title = file.name.replace(/\.pdf$/i, '');
                await this.service.render();
            };
            reader.readAsDataURL(file);
        };
        node.click();
    }

    public async saveImport() {
        if (!this.draft.title) {
            await this.service.modal.error('제목을 입력해주세요.');
            return;
        }
        if (this.importMode === 'html' && !this.draft.html) {
            await this.service.modal.error('HTML 파일 또는 내용을 추가해주세요.');
            return;
        }
        if (this.importMode === 'pdf' && !this.draft.data_url) {
            await this.service.modal.error('PDF 파일을 선택해주세요.');
            return;
        }

        const payload = {
            ...this.draft,
            tags: String(this.draft.tags || '').split(',').map((tag: string) => tag.trim()).filter(Boolean)
        };
        const fn = this.importMode === 'pdf' ? 'import_pdf' : 'import_html';
        const { code, data }: any = await wiz.call(fn, { data: JSON.stringify(payload) });
        if (code === 401) return this.redirectAccess();
        if (code !== 200) {
            await this.service.modal.error(data?.message || '등록에 실패했습니다.');
            return;
        }

        this.closeImport();
        await this.loadList();
        await this.openDocument({ id: data.id });
    }

    public async printDocument() {
        if (!this.bundle?.document?.id) return;
        const { code, data }: any = await wiz.call('print', {
            id: this.bundle.document.id,
            adapter: this.bundle.current?.source_type === 'pdf' ? 'native_pdf' : 'browser_print',
            profile: JSON.stringify({ media: 'print', page: 'A4' })
        });
        if (code === 401) return this.redirectAccess();
        if (code !== 200) {
            await this.service.modal.error(data?.message || '인쇄 준비에 실패했습니다.');
            return;
        }

        if (data.warning) await this.service.modal.warning(data.warning, false, '확인');
        if (data.print_strategy === 'open_pdf') {
            window.open(data.print_url, '_blank');
            return;
        }
        this.printUrl(data.print_url);
    }

    public openSource() {
        if (!this.preview?.source_url) return;
        window.open(this.preview.source_url, '_blank');
    }

    public openPdf() {
        const url = this.bundle?.current?.pdf_url || this.pdfUrl;
        if (!url) return;
        window.open(url, '_blank');
    }

    private redirectAccess() {
        const returnTo = encodeURIComponent(location.pathname + location.search);
        location.href = `/access?returnTo=${returnTo}`;
    }

    private printUrl(url: string) {
        const frame = document.createElement('iframe');
        frame.style.position = 'fixed';
        frame.style.right = '0';
        frame.style.bottom = '0';
        frame.style.width = '0';
        frame.style.height = '0';
        frame.style.border = '0';
        frame.src = url;
        frame.onload = () => {
            setTimeout(() => {
                frame.contentWindow?.focus();
                frame.contentWindow?.print();
                setTimeout(() => frame.remove(), 1000);
            }, 300);
        };
        document.body.appendChild(frame);
    }
}

export default PortalArchiveViewerComponent;